class GallerySliders {

    constructor() {
        this.init();
        this.handleShopifySectionLoad(); // Initialize Shopify section load handler
    }

    initMobilePdpGallerySlider() {
        const mobileSliderOptions = {
            arrows: false,
            pagination: false,
        };

        const mobileSliderElement = document.querySelector('#splide-slider');
        if (mobileSliderElement) {
            if (mobileSliderElement.splide) {
                mobileSliderElement.splide.destroy();
            }
            const mobileSlider = new Splide(mobileSliderElement, mobileSliderOptions);
            mobileSlider.mount();
        }
    }

    initDesktopPdpGallerySlider() {
        const desktopMainSliderOptions = {
            type: 'fade',
            heightRatio: 0.5,
            pagination: false,
            arrows: false,
            cover: true,
        };

        const thumbnailsSliderOptions = {
            rewind: true,
            fixedWidth: 77,
            fixedHeight: 77,
            isNavigation: true,
            gap: 10,
            direction: 'ttb',
            height: 450,
            pagination: false,
            dragMinThreshold: {
                mouse: 4,
                touch: 10,
            },
        };

        const desktopMainSliderElement = document.querySelector('#main-slider');
        const desktopThumbnailSliderElement = document.querySelector('#thumbnail-slider');

        if (desktopMainSliderElement && desktopThumbnailSliderElement) {
            if (desktopMainSliderElement.splide) {
                desktopMainSliderElement.splide.destroy();
            }
            if (desktopThumbnailSliderElement.splide) {
                desktopThumbnailSliderElement.splide.destroy();
            }

            const desktopMainSlider = new Splide(desktopMainSliderElement, desktopMainSliderOptions);
            const desktopThumbnailSlider = new Splide(desktopThumbnailSliderElement, thumbnailsSliderOptions);

            desktopMainSlider.sync(desktopThumbnailSlider);
            desktopMainSlider.mount();
            desktopThumbnailSlider.mount();
        }
    }

    handleSplideSlider() {
        const mediaModal = document.querySelector('#media-modal');

        if (mediaModal) {
            if (mediaModal.splide) {
                mediaModal.splide.destroy();
            }
            mediaModal.splideInstance = new Splide(mediaModal, {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                mobileFirst: true,
                arrows: true,
                pagination: false,
                breakpoints: {
                    992: {
                        perPage: 1,
                        centerMode: true,
                        variableWidth: false,
                    },
                },
            }).mount();
        }
    }

    initModal() {
        this.openModal = (imageUrl) => {
            const modal = document.getElementById('media-modal');
            const modalImage = document.getElementById('modal-image');
            modalImage.src = imageUrl;
            modal.classList.add('active');
            document.body.style.overflow = 'hidden';
        };

        this.closeModal = () => {
            const modal = document.getElementById('media-modal');
            modal.classList.remove('active');
            document.body.style.overflow = 'unset';
        };

        document.querySelectorAll('.main-image-media-gallery').forEach((thumbnail) => {
            thumbnail.addEventListener('click', () => {
                const imageUrl = thumbnail.src;
                this.openModal(imageUrl);
            });
        });

        window.closeModal = this.closeModal;

        document.getElementById('media-modal').addEventListener('click', (e) => {
            if (e.target === e.currentTarget) {
                this.closeModal();
            }
        });
    }

    handleShopifySectionLoad() {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.target.querySelector('#splide-slider')) {
                this.initMobilePdpGallerySlider();
            }
            if (event.target.querySelector('#main-slider') || event.target.querySelector('#thumbnail-slider')) {
                this.initDesktopPdpGallerySlider();
            }
            if (event.target.querySelector('#media-modal')) {
                this.handleSplideSlider();
            }
        });
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.initMobilePdpGallerySlider();
            this.initDesktopPdpGallerySlider();
            this.initModal();
            this.handleSplideSlider();
        });
    }
}

let gallerySlider = new GallerySliders();
